import {
    PhoenixTask,
    TaskSearchFlags,
    ShareBaseDocument,
    ShareBaseFolder
} from 'phoenix/domain';
import { QueryStringFilter } from 'phoenix/filters/queryStringUri';
import { IUriPathService } from 'phoenix/services';

interface TaskCompletionData {
    Result: string,
    ExternalAssigneeEmail: string,
    Comment?: string
}

export class TaskService {
    
    public static readonly $inject: string[] = [
        '$http',
        'pxUriPathService',
        'pxQueryStringFilter'
    ];

    constructor(
        private readonly $http:ng.IHttpService, 
        private readonly pxUriPathService:IUriPathService,
        private readonly pxQueryStringFilter:QueryStringFilter
    ) { }
   
    public createTaskForDocument(task: PhoenixTask, document: ShareBaseDocument) {
        return this.$http.post<PhoenixTask>(this.pxUriPathService.resolvePath(`/documents/${document.DocumentId}/tasks`), task)
            .then(response => response.data);
	}
    
    public completeTask(task: PhoenixTask, completionComment?: string) {
        let taskCompletionData:TaskCompletionData = {
            Result: task.TaskResult,
            ExternalAssigneeEmail: task.ExternalAssigneeEmail
        };

        if (completionComment) {
            taskCompletionData.Comment = completionComment;
        }

        return this.$http.patch<PhoenixTask>(task.Links.CompleteTaskUri, taskCompletionData)
            .then(response => response.data);
    }

    public cancelTask(task: PhoenixTask) {
        let path = this.pxUriPathService.resolvePath(`/tasks/${task.TaskId}/cancel/`);
        
        return this.$http.patch<PhoenixTask>(path, {})
            .then(response => response.data);
    }

	public getDocumentTasksAssignedToUser(document: ShareBaseDocument, taskSearchFlags: TaskSearchFlags, assigneeEmail?: string) {
        let path = this.getAssignedTasksUri(
            this.pxUriPathService.resolvePath(`/documents/${document.DocumentId}/my-assigned-tasks?taskSearchFlags=${taskSearchFlags}`),
            assigneeEmail
        );
        return this.$http.get<PhoenixTask[]>(path)
            .then(response => response.data);
    }

    public getFolderTasksAssignedToUser(folder: ShareBaseFolder, taskSearchFlags: TaskSearchFlags, assigneeEmail?: string) {
        let path = this.getAssignedTasksUri(
            this.pxUriPathService.resolvePath(`/folders/${folder.FolderId}/my-assigned-tasks?taskSearchFlags=${taskSearchFlags}`),
            assigneeEmail
        );
        return this.$http.get<PhoenixTask[]>(path)
            .then(response => response.data);
    }

	public getAssignedTasksForUser(taskSearchFlags: TaskSearchFlags, assigneeEmail?: string) {
        let path = this.getAssignedTasksUri(
            this.pxUriPathService.resolvePath(`/my-assigned-tasks?taskSearchFlags=${taskSearchFlags}`),
            assigneeEmail
        );
		return this.$http.get<PhoenixTask[]>(path)
            .then(response => response.data);
    }
    
    public getCreatedTasksForUser(taskSearchFlags: TaskSearchFlags) {
        return this.$http.get<PhoenixTask[]>(this.pxUriPathService.resolvePath(`/my-created-tasks?taskSearchFlags=${taskSearchFlags}`))
            .then(response => response.data);
    }

    public getTask(taskId: number) {
        let path = this.pxUriPathService.resolvePath(`/tasks/${taskId}`);
        
        return this.$http.get<PhoenixTask>(path, {})
            .then(response => response.data);
    }

    private getAssignedTasksUri(baseUri:string, assigneeEmail?:string) {
        return assigneeEmail ? this.pxQueryStringFilter(baseUri, {assigneeEmail}) : baseUri;
    }
}


// WEBPACK FOOTER //
// ./src/phoenix/services/taskService.ts